<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMDeviceBrandList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-card-title>{{$t('views.excmdevicebrand.update.title')}}  {{ item && item['brandTitle'] }}</b-card-title>
            <EXCMDeviceBrandForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDeviceBrandForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMDeviceBrandForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceBrandUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdevicebrand/update/isLoading',
      error: 'excmdevicebrand/update/error',
      deleteError: 'excmdevicebrand/del/error',
      deleteLoading: 'excmdevicebrand/del/isLoading',
      created: 'excmdevicebrand/create/created',
      deleted: 'excmdevicebrand/del/deleted',
      retrieved: 'excmdevicebrand/update/retrieved',
      updated: 'excmdevicebrand/update/updated',
      violations: 'excmdevicebrand/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDeviceBrandList' })
    },

    updated: function () {
      this.$router.push({ name: 'EXCMDeviceBrandList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdevicebrand/create/reset',
      deleteItem: 'excmdevicebrand/del/del',
      delReset: 'excmdevicebrand/del/reset',
      retrieve: 'excmdevicebrand/update/retrieve',
      updateReset: 'excmdevicebrand/update/reset',
      update: 'excmdevicebrand/update/update',
      updateRetrieved: 'excmdevicebrand/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdevicebrand ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
